import {Button, Typography} from "@mui/material";
import {
  AppRouteUrl,
  GeneralPageTemplate,
  paperAirplane,
} from "@pinch-financial/pinch-ui-components";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {migrateUser as migrateUserApi} from "~/api/auth";

interface Props {
  containerRef?: React.RefObject<HTMLDivElement>;
}

const MigrateOktaSuccessPage = ({containerRef}: Props) => {
  const {t: fixedT} = useTranslation("", {keyPrefix: "migrateOktaSuccessPage"});

  const location = useLocation();

  const navigate = useNavigate();
  const [searchParams, _setSearchParams] = useSearchParams();

  const migrateUser = async (email: string) => {
    if (email) {
      const response = await migrateUserApi(email);
      if (response.error) {
        console.error("Error migrating user:", response.error);
      }
    } else {
      navigate(AppRouteUrl.LANDING_PAGE_URL);
    }
  };

  useEffect(() => {
    migrateUser(
      searchParams.get("email") ||
        searchParams.get("migrateemail") ||
        searchParams.get("migrateEmail") ||
        location.state?.username
    );
  }, [searchParams]);

  const onSubmit = () => {
    navigate(AppRouteUrl.SIGN_IN);
  };

  return (
    <GeneralPageTemplate ref={containerRef} navigationBar={<></>} iconSrc={paperAirplane}>
      <Typography variant="h1">{fixedT("title")}</Typography>
      <Typography mt={4} mb={4}>
        {fixedT("message")}
      </Typography>
      <Button onClick={() => onSubmit()} variant="contained">
        {fixedT("submit")}
      </Button>
    </GeneralPageTemplate>
  );
};

export default MigrateOktaSuccessPage;
